// team/shared/components/TeamPhoneInputField.js
import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Box, FormHelperText } from '@mui/material';

/**
 * Phone input field component with country code selector
 * Wraps react-phone-input-2 to match the application styling
 */
const TeamPhoneInputField = ({
    value,
    onChange,
    error = '',
    label = 'Phone Number',
    country = 'sg',
    inputStyle = {},
    containerStyle = {},
    buttonStyle = {},
    dropdownStyle = {},
    inputProps = {},
    disabled = false,
    enableSearch = true,
    disableSearchIcon = false,
    autoFormat = true,
    preferredCountries = ['sg', 'us', 'gb', 'au', 'in'],
    placeholder = 'Enter phone number',
    required = false,
}) => {
    // Handle change and normalize the format
    const handleChange = (value) => {
        // Remove any non-digit characters except +
        const cleanedValue = value.replace(/[^\d+]/g, '');
        onChange(cleanedValue);
    };

    // Default styles that match Material-UI theme
    const defaultInputStyle = {
        width: '100%',
        height: '56px',
        border: error ? '2px solid #f44336' : '1px solid #c4c4c4',
        borderRadius: '4px',
        fontSize: '16px',
        padding: '0 14px',
        fontFamily: 'Roboto, sans-serif',
        ...inputStyle
    };

    const defaultContainerStyle = {
        width: '100%',
        ...containerStyle
    };

    const defaultButtonStyle = {
        border: error ? '2px solid #f44336' : '1px solid #c4c4c4',
        borderRadius: '4px 0 0 4px',
        backgroundColor: '#f5f5f5',
        ...buttonStyle
    };

    const defaultDropdownStyle = {
        border: '1px solid #c4c4c4',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        ...dropdownStyle
    };

    return (
        <Box sx={{ width: '100%' }}>
            {required && label && (
                <Box sx={{ mb: 0.5, ml: 1.75, fontSize: '0.75rem', color: 'text.secondary' }}>
                    {label} <span style={{ color: '#d32f2f' }}>*</span>
                </Box>
            )}
            <PhoneInput
                country={country}
                value={value}
                onChange={handleChange}
                disabled={disabled}
                enableSearch={enableSearch}
                disableSearchIcon={disableSearchIcon}
                autoFormat={autoFormat}
                preferredCountries={preferredCountries}
                placeholder={placeholder}
                inputStyle={defaultInputStyle}
                containerStyle={defaultContainerStyle}
                buttonStyle={defaultButtonStyle}
                dropdownStyle={defaultDropdownStyle}
                inputProps={{
                    ...inputProps,
                    'aria-label': label,
                    'aria-invalid': !!error,
                    'aria-required': required
                }}
                specialLabel=""
            />
            {error && (
                <FormHelperText error sx={{ mt: 0.5, mx: 1.75 }}>
                    {error}
                </FormHelperText>
            )}
        </Box>
    );
};

TeamPhoneInputField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    label: PropTypes.string,
    country: PropTypes.string,
    inputStyle: PropTypes.object,
    containerStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    dropdownStyle: PropTypes.object,
    inputProps: PropTypes.object,
    disabled: PropTypes.bool,
    enableSearch: PropTypes.bool,
    disableSearchIcon: PropTypes.bool,
    autoFormat: PropTypes.bool,
    preferredCountries: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
    required: PropTypes.bool,
};

export default TeamPhoneInputField;




